"use client";

import { create } from "zustand";
interface ProductStore {
  currentHashId: string;
  setCurrentHashId: (hashId: string) => void;
}
export const useProductStore = create<ProductStore>((set) => ({
  currentHashId: "",
  setCurrentHashId: (hashId: string) => set({ currentHashId: hashId }),
}));
